
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { FieldItemProps } from ".";
import { loading, fieldCreate } from "store/form";
import { AppMessage } from "components";

interface ApiFieldCreateInputProps extends Omit<FieldItemProps, "id"> {
}

type ApiFieldCreateOutputProps = OutputBaseProps<{ item: FieldItemProps; }, ApiFieldCreateInputProps>

export const apiFieldCreate = async (data: ApiFieldCreateInputProps, formId: number) => {
    store.dispatch(loading());
    const initData = { translate: false, multiple: false, required: false, unique: false }
    const res = (await axios.post<ApiFieldCreateOutputProps>(`/api/form/${formId}/field/create`, { ...initData, ...data }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(fieldCreate({ data: res.data.item }));
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};